export const version = "6.1.10";
export const major = Number("6");
export const minor = Number("1");
export const patch = Number("10");
export const prerelease = undefined;
export default version;